var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 51 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffffff;}.cls-2{fill:none;stroke:#ffffff;stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.57,21.86l-1-1L32,19.24l-1.72-1.73L29.11,16.4l-.92.93L22.42,23.1,17,28.57,15,30.51l-.67,2.8c-.15.66-1.35,3.86-.5,4.16a.6.6,0,0,0,.3,0L18,36.55,20.46,36,22.4,34l5.48-5.48,5.77-5.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.47,18.4a1.92,1.92,0,0,0-.55-1.2c-.48-.58-1.1-1.18-1.52-1.6s-.91-.93-1.41-1.4a2.06,2.06,0,0,0-1.42-.7,1.7,1.7,0,0,0-1.09.49,15.26,15.26,0,0,0-1.27,1.32l1.25,1.25L33,18.05l1.64,1.64,1.07,1.07c.35-.35.91-.78,1.32-1.26A1.78,1.78,0,0,0,37.47,18.4Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 25.5,
    cy: 25.5,
    r: 25
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.22e29a0eca5fd44aa1dc432c28bcb173.svg";
export { ForwardRef as ReactComponent };